import { Component, Input, SimpleChanges } from "@angular/core";
import { formatCell } from "src/app/utils/common";
import { VAIconRegistryService, infoCircle } from "@va/core-library/icons";
@Component({
  selector: "app-drug-sales-summary-pipeline-drug",
  templateUrl: "./drug-sales-summary-pipeline-drug.component.html",
  styleUrls: ["./drug-sales-summary-pipeline-drug.component.scss"],
})
export class DrugSalesSummaryPipelineDrugComponent {
  @Input() data;
  constructor(private iconRegistryService: VAIconRegistryService) {
    this.iconRegistryService.registerIcons([infoCircle]);
  }
  ngOnChanges(changes: SimpleChanges) {
    if (
      changes &&
      changes.data &&
      changes.data.currentValue &&
      changes.data.currentValue.pipeline
    ) {
      const pipelineData = changes.data.currentValue.pipeline;
      const metaData = changes.data.currentValue.meta_data;

      const brokerAvg = formatCell(
        pipelineData.analyst_avg_value,
        metaData.currency,
        metaData.unit,
        "values",
      );
      pipelineData["analyst_avg_value_formatted"] = brokerAvg;

      const fiveYrsAggSum = formatCell(
        pipelineData.five_year_aggregate_sum,
        metaData.currency,
        metaData.unit,
        "values",
      );
      pipelineData["five_year_aggregate_sum_formatted"] = fiveYrsAggSum;

      const peakValue = formatCell(
        pipelineData.peak_value,
        metaData.currency,
        metaData.unit,
        "values",
      );
      pipelineData["peak_value_formatted"] = peakValue;

      const posValue = formatCell(
        pipelineData.p_o_s,
        metaData.currency,
        metaData.unit,
        "yoy",
      );
      pipelineData["p_o_s_formatted"] = posValue;
    }
  }
}
